import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Besttaxiserviceinshirdi() {



  const cardData =
  {
    keyword: 'Best Taxi Service in Shirdi',
    heading: 'Sanavi Travels: Best Taxi Service in Shirdi',
    headingDescription: 'Sanavi Travels offers the Best Taxi Service in Shirdi, providing safe, reliable, and comfortable transportation for pilgrims, families, and tourists visiting the holy town. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury taxis ensures clean interiors, air-conditioning, and ample luggage space for a smooth and peaceful journey. With professional, courteous chauffeurs, flexible local and outstation taxi packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, hassle-free, and dependable service. We provide convenient taxi services for Shirdi local sightseeing, Shirdi to Shani Shingnapur, Shirdi to Nashik, Pune, Mumbai, and Aurangabad, making us a trusted choice for temple visits and travel needs. Choose Sanavi Travels for the best taxi services in Shirdi, delivering comfort, safety, and a spiritually fulfilling travel experience.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi Sai Baba Temple is one of India’s most revered pilgrimage sites, dedicated to Sai Baba. Devotees from all religions visit the temple seeking blessings, faith, and inner peace. The daily aartis and well-organized darshan system make the spiritual experience deeply fulfilling."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the sacred mosque where Sai Baba lived for many years and performed miracles. The holy dhuni (sacred fire) still burns here, symbolizing faith and protection. It holds immense spiritual importance for Sai Baba devotees."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is a historic place where Sai Baba used to rest on alternate nights. Processions are held every Thursday and festival days, recreating Sai Baba’s routine and preserving the traditions followed during his lifetime."
  },
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Samadhi Mandir houses the tomb of Sai Baba and is the central shrine of Shirdi. Devotees experience a profound sense of devotion and peace while offering prayers at the samadhi, making it the heart of Shirdi pilgrimage."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a peaceful garden where Sai Baba spent time meditating. It features the Nanda Deep lamp, which is continuously lit, and is considered a place of calm, reflection, and spiritual healing."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple holds historical importance as the place where Sai Baba was first welcomed into Shirdi. The temple is associated with Sai Baba’s early days and remains an important stop for pilgrims."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a devotional theme park showcasing scenes from Sai Baba’s life through statues and recreated settings. It helps visitors understand Sai Baba’s teachings and daily life in a visual and engaging way."
  },
  {
    "title": "Abdul Baba’s Cottage",
    "description": "Abdul Baba’s Cottage is dedicated to one of Sai Baba’s closest disciples. The site reflects the deep bond between Sai Baba and Abdul Baba and is visited by devotees seeking blessings and spiritual inspiration."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Located near Shirdi, Shani Shingnapur is famous for its open-door houses and the powerful temple of Lord Shani. Devotees often visit this temple along with Shirdi, believing it removes obstacles and negative influences."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers a fun-filled recreational experience for families visiting Shirdi. With water rides, wave pools, and entertainment zones, it provides a refreshing break alongside spiritual travel."
  }
]
,



"services": [
  {
    "name": "Best Taxi Service in Shirdi",
    "description": "Best Taxi Service in Shirdi offers reliable, comfortable, and professional taxi solutions for devotees and tourists visiting Sai Baba Temple. Well-maintained, air-conditioned taxis with clean interiors and comfortable seating ensure a smooth travel experience. Experienced chauffeurs manage traffic, routes, and temple-area navigation efficiently, ensuring timely pickups and drop-offs. Ideal for families, senior citizens, and pilgrims, this service supports local travel, outstation trips, airport transfers, and flexible travel schedules across Shirdi."
  },
  {
    "name": "Top Taxi Service Shirdi",
    "description": "Top Taxi Service Shirdi provides high-quality taxi services focused on punctuality, safety, and passenger comfort. Air-conditioned vehicles with professional drivers ensure stress-free travel for temple darshan, hotel transfers, sightseeing, and nearby city trips. Known for courteous service and reliability, this option is suitable for families, tourists, and regular visitors seeking dependable transportation in Shirdi."
  },
  {
    "name": "AC Taxi Shirdi",
    "description": "AC Taxi Shirdi ensures a cool and relaxing journey, especially during warm weather and long travel hours. Fully air-conditioned taxis with comfortable seating and smooth suspension reduce travel fatigue. Skilled chauffeurs ensure safe driving and efficient route planning, making this service ideal for Sai Mandir visits, sightseeing, and outstation journeys from Shirdi."
  },
  {
    "name": "Affordable Taxi Shirdi",
    "description": "Affordable Taxi Shirdi offers budget-friendly taxi services without compromising on safety or comfort. Clean, air-conditioned taxis with experienced drivers ensure smooth and economical travel. Ideal for families, pilgrims, and solo travelers, this service balances affordability, reliability, and convenience for local and outstation travel in Shirdi."
  },
  {
    "name": "Local Taxi Shirdi",
    "description": "Local Taxi Shirdi is perfect for short-distance travel within Shirdi, including Sai Baba Temple visits, hotels, and nearby attractions. Comfortable AC taxis with knowledgeable local drivers ensure quick and convenient transportation. Suitable for all age groups, this service offers flexible timings and easy availability around the temple area."
  },
  {
    "name": "Outstation Taxi Shirdi",
    "description": "Outstation Taxi Shirdi provides dependable long-distance travel options from Shirdi to nearby cities and pilgrimage destinations. Well-maintained, air-conditioned vehicles with professional chauffeurs ensure safe highway driving, comfortable seating, and timely arrivals. Ideal for family trips, temple tours, and extended travel plans."
  },
  {
    "name": "Chauffeur Driven Taxi Shirdi",
    "description": "Chauffeur Driven Taxi Shirdi offers a stress-free travel experience with trained drivers handling navigation, traffic, and schedules. Comfortable air-conditioned taxis allow passengers to relax during darshan visits, sightseeing, and outstation journeys. Especially suitable for elderly devotees, families, and tourists seeking safe and reliable transport."
  },
  {
    "name": "Family Taxi Shirdi",
    "description": "Family Taxi Shirdi is designed for safe and comfortable family travel. Spacious air-conditioned taxis with sufficient luggage space accommodate families easily. Professional chauffeurs ensure smooth driving, flexible travel plans, and timely temple visits, making it ideal for family darshan trips and sightseeing in Shirdi."
  },
  {
    "name": "Tourist Taxi Shirdi",
    "description": "Tourist Taxi Shirdi provides organized transportation for tourists visiting Shirdi and nearby attractions. Comfortable AC taxis with experienced and courteous drivers ensure a pleasant sightseeing experience. Perfect for couples, families, and groups planning temple visits, local tours, and leisure travel."
  },
  {
    "name": "Sai Baba Temple Taxi",
    "description": "Sai Baba Temple Taxi offers convenient taxi services focused on temple visits and darshan schedules. Easily accessible taxis near the temple area ensure quick pickups and drop-offs. Ideal for elderly devotees and families, this service provides comfortable vehicles, experienced drivers, and smooth temple-area travel."
  },
  {
    "name": "Shirdi Cab Booking",
    "description": "Shirdi Cab Booking allows easy and quick booking of taxis for local, outstation, and airport travel. Customers can select taxi type, pickup location, travel duration, and trip preferences with reliable service assurance. Air-conditioned vehicles with professional chauffeurs ensure safe and comfortable journeys throughout Shirdi."
  },
  {
    "name": "Reliable Taxi Shirdi",
    "description": "Reliable Taxi Shirdi focuses on consistent service quality, punctuality, and passenger safety. Well-maintained taxis with trained drivers ensure smooth travel for temple visits, sightseeing, and long-distance trips. Ideal for regular visitors, families, and pilgrims seeking dependable transportation in Shirdi."
  },
  {
    "name": "24x7 Taxi Shirdi",
    "description": "24x7 Taxi Shirdi provides round-the-clock taxi availability for early morning darshan, late-night arrivals, and emergency travel needs. Air-conditioned taxis with professional chauffeurs ensure safe and timely service at any hour. Suitable for pilgrims, tourists, and business travelers requiring flexible travel options."
  },
  {
    "name": "Shirdi Airport Taxi",
    "description": "Shirdi Airport Taxi ensures punctual and hassle-free transfers between Shirdi and nearby airports. Drivers track flight schedules to provide timely pickups and drops in comfortable, air-conditioned vehicles. Ideal for devotees, tourists, and corporate travelers seeking smooth airport connectivity."
  },
  {
    "name": "Shirdi Travel Taxi",
    "description": "Shirdi Travel Taxi offers dedicated taxi solutions for pilgrims and tourists visiting Shirdi. Comfortable AC taxis with experienced chauffeurs ensure smooth travel for darshan, sightseeing, and outstation journeys. This service emphasizes comfort, safety, flexibility, and a peaceful travel experience."
  }
],
"tableData": [
  ["Best Taxi Service in Shirdi", "Top Taxi Service Shirdi"],
  ["AC Taxi Shirdi", "Affordable Taxi Shirdi"],
  ["Local Taxi Shirdi", "Outstation Taxi Shirdi"],
  ["Chauffeur Driven Taxi Shirdi", "Family Taxi Shirdi"],
  ["Tourist Taxi Shirdi", "Sai Baba Temple Taxi"],
  ["Shirdi Cab Booking", "Reliable Taxi Shirdi"],
  ["24x7 Taxi Shirdi", "Shirdi Airport Taxi"],
  ["Shirdi Travel Taxi", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Best Taxi Service in Shirdi with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers the best taxi service in Shirdi, ideal for local travel, temple visits, sightseeing, airport transfers, and outstation trips."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Taxis",
    "WhyChoosedescription": "Travel in well-maintained, air-conditioned taxis that provide a smooth and comfortable ride throughout Shirdi and nearby areas."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and knowledgeable about local routes, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all taxi services in Shirdi, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Choose from immediate bookings, advance reservations, one-way, round-trip, or hourly taxi services based on your needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All taxis are thoroughly cleaned and sanitized before every ride to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for taxi services in Shirdi."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide taxi services in Shirdi?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable taxi services in Shirdi for local and outstation travel.'
  },
  {
    question: 'How can I book a taxi in Shirdi?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of taxis are available in Shirdi?',
    answer: 'Sanavi Travels provides hatchbacks, sedans, SUVs, and premium cars to suit your travel preferences.'
  },
  {
    question: 'Are drivers experienced with local Shirdi routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with all Shirdi routes for safe and efficient travel.'
  },
  {
    question: 'Can I book a taxi for sightseeing in Shirdi?',
    answer: 'Absolutely. You can book taxis for temple visits, local sightseeing, and nearby attractions.'
  },
  {
    question: 'Is taxi service available 24x7 in Shirdi?',
    answer: 'Yes, Sanavi Travels offers round-the-clock taxi services in Shirdi.'
  },
  {
    question: 'Are the taxis sanitized before every ride?',
    answer: 'Yes, all taxis are thoroughly cleaned and sanitized before each trip.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and cash payments.'
  },
  {
    question: 'Is customer support available during the taxi ride?',
    answer: 'Yes, our 24x7 customer support team is available throughout your journey in Shirdi.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Deshpande',
    feedback: 'Booked a taxi in Shirdi with Sanavi Travels. The service was excellent, and the driver was friendly.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Sharma',
    feedback: 'Very reliable taxi service in Shirdi with punctual pickups and comfortable ride. Highly recommend!',
    rating: 5
  }
];








































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Taxi Service in Shirdi - Sanavi Travels",
  "description": "Book the best taxi service in Shirdi with Sanavi Travels. AC and chauffeur-driven taxis for Sai Baba Temple visits, airport pickups, local travel, family trips, outstation journeys, and tourist sightseeing.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};








  return (
    <div>
<Helmet>
  <title>
    Best Taxi Service in Shirdi | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and chauffeur-driven taxis in Shirdi with Sanavi Travels. Perfect for Sai Baba Temple visits, airport pickups, local travel, family trips, outstation journeys, and safe tourist rides."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/175.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Besttaxiserviceinshirdi;